// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8336) return "static/chunks/8336-d42b1c154e2fc456.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1006":"f32584fa14ee7354","4524":"3343db2cced9ddd3","8625":"4f6c49056cafff45"}[chunkId] + ".js";
};